const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function track(event, meta) {
  try {
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event,
        meta: meta ? String(meta).slice(0, 300) : null,
        path: window.location.pathname,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // analytics must never break the site
  }
}

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;
  document.addEventListener("click", (e) => {
    const el = e.target.closest("[data-track]");
    if (el) track(el.getAttribute("data-track"));
  });
  window.addEventListener("message", (e) => {
    if (e.data && e.data.event === "calendly.event_scheduled") {
      track("calendly_booking_confirmed");
    }
  });
}
